import { render, staticRenderFns } from "./KioskInputWrapper.vue?vue&type=template&id=30858d63&scoped=true"
import script from "./KioskInputWrapper.vue?vue&type=script&lang=js"
export * from "./KioskInputWrapper.vue?vue&type=script&lang=js"
import style0 from "./KioskInputWrapper.vue?vue&type=style&index=0&id=30858d63&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30858d63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30858d63')) {
      api.createRecord('30858d63', component.options)
    } else {
      api.reload('30858d63', component.options)
    }
    module.hot.accept("./KioskInputWrapper.vue?vue&type=template&id=30858d63&scoped=true", function () {
      api.rerender('30858d63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/kiosk/KioskInputWrapper.vue"
export default component.exports